import React, { useRef, useEffect } from 'react';
import './HotSauceLogo.css';
import {
  registerCutout,
  unregisterCutout,
  findOpaqueCutout,
  syncCutoutHover
} from '../utils/cutoutHit';

const LOGO_URL = 'https://www.youtube.com/@hotsauceuniverse';

const HotSauceLogo = () => {
  const canvasRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const img = imgRef.current;
    const canvas = canvasRef.current;

    if (!img || !canvas) return;

    const loadImage = () => {
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      registerCutout(img, canvas);
    };

    if (img.complete && img.naturalWidth) {
      loadImage();
    } else {
      img.addEventListener('load', loadImage);
      return () => {
        img.removeEventListener('load', loadImage);
        unregisterCutout(img);
      };
    }

    return () => unregisterCutout(img);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const target = findOpaqueCutout(e.clientX, e.clientY);
    const href = target?.dataset?.href;
    if (href) {
      window.open(href, '_blank');
    }
  };

  const handleMouseMove = (e) => {
    syncCutoutHover(e.clientX, e.clientY);
  };

  return (
    <div className="logo-container">
      <img
        ref={imgRef}
        src="/핫소스_AnyMaking.png"
        alt="핫소스 로고"
        className="logo"
        data-href={LOGO_URL}
        crossOrigin="anonymous"
        onClick={handleClick}
        onMouseMove={handleMouseMove}
      />
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  );
};

export default HotSauceLogo;
